<template>
  <div>
    <article class="con4">
      <div class="top">
        <p>말하고 싶은 목적과 레벨에 맞는<br />다양한 커리큘럼</p>
        <ul>
          <li
            @click="
              goSite('https://www.carrotenglish.kr/phone/program_china_map')
            "
          >
            커리큘럼 보기
          </li>
          <li
            @click="
              goSite(
                'https://kr.object.ncloudstorage.com/carrotchinese/%EB%8B%B9%EA%B7%BC%20%EC%A4%91%EA%B5%AD%EC%96%B4%20%EB%93%B1%EA%B8%89%ED%91%9C.png'
              )
            "
          >
            등급표 보기
          </li>
        </ul>
      </div>
      <div class="bottom">
        <div class="container">
          <VueSlickCarousel ref="c1" v-bind="settings1" class="title-slide">
            <div>
              <p>정규회화코스</p>
            </div>
            <div>
              <p>비즈니스회화/스킬 코스</p>
            </div>
            <div>
              <p>테마 코스</p>
            </div>
            <div>
              <p>토론 코스</p>
            </div>
            <div>
              <p>시험대비 코스</p>
            </div>
            <div>
              <p>주니어 중국어</p>
            </div>
          </VueSlickCarousel>
          <VueSlickCarousel ref="c2" v-bind="settings2" class="content-slide">
            <div>
              <p class="text1">정규회화코스</p>
              <p class="text2">
                실제 상황별 표현을 통해 기본기를 다지고<br />회화에 꼭 필요한
                필수 표현 습득으로 중국어 자신감과 재미를 200% 보장합니다.
              </p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-1.png"
                    alt="img"
                  />
                  <p class="book-title">기초중심</p>
                  <ul class="book-level">
                    <li>1 입문</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EC%B4%88%EC%A4%91%EC%8B%AC.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-2.png"
                    alt="img"
                  />
                  <p class="book-title">기본중심1</p>
                  <ul class="book-level">
                    <li>1 입문</li>
                    <li>2 초급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%A4%91%EC%8B%AC1.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-3.png"
                    alt="img"
                  />
                  <p class="book-title">기본중심2</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%A4%91%EC%8B%AC2.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-4.png"
                    alt="img"
                  />
                  <p class="book-title">기본심화3</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%8B%AC%ED%99%943.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-5.png"
                    alt="img"
                  />
                  <p class="book-title">기본심화4</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                    <li>3 중급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EA%B8%B0%EB%B3%B8%EC%8B%AC%ED%99%944.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-6.png"
                    alt="img"
                  />
                  <p class="book-title">스피킹 중심5</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EC%8A%A4%ED%94%BC%ED%82%B9%20%EC%A4%91%EC%8B%AC5.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-7.png"
                    alt="img"
                  />
                  <p class="book-title">스피킹 중심6</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EC%8A%A4%ED%94%BC%ED%82%B9%20%EC%A4%91%EC%8B%AC6.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item1-8.png"
                    alt="img"
                  />
                  <p class="book-title">스피킹 심화7</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/1%EC%A0%95%EA%B7%9C%ED%9A%8C%ED%99%94%EC%BD%94%EC%8A%A4/%EC%8A%A4%ED%94%BC%ED%82%B9%20%EC%8B%AC%ED%99%947.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <p class="text1">비즈니스회화/스킬 코스</p>
              <p class="text2">
                기업 교육에 최적화된 중국어 비즈니스 교재!<br />최신 비즈니스
                전문 교재로 중국 비즈니스 역량을 향상합니다.
              </p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item2-1.png"
                    alt="img"
                  />
                  <p class="book-title">비즈니스<br />베이직 기본</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                    <li>3 중급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/2%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%ED%9A%8C%ED%99%94/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%20%EB%B2%A0%EC%9D%B4%EC%A7%81%20%EA%B8%B0%EB%B3%B8.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item2-2.png"
                    alt="img"
                  />
                  <p class="book-title">비즈니스<br />프렉티스 심화</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/2%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%ED%9A%8C%ED%99%94/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%20%ED%94%84%EB%A0%89%ED%8B%B0%EC%8A%A4%20%EC%8B%AC%ED%99%94.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item2-3.png"
                    alt="img"
                  />
                  <p class="book-title">비즈니스 스킬<br />출장</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/2%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%ED%9A%8C%ED%99%94/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%20%EC%8A%A4%ED%82%AC%20%EC%B6%9C%EC%9E%A5.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item2-4.png"
                    alt="img"
                  />
                  <p class="book-title">비즈니스 스킬<br />미팅</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/2%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%ED%9A%8C%ED%99%94/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%20%EC%8A%A4%ED%82%AC%20%EB%AF%B8%ED%8C%85.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item2-5.png"
                    alt="img"
                  />
                  <p class="book-title">비즈니스 스킬<br />프레젠테이션</p>
                  <ul class="book-level">
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/2%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%ED%9A%8C%ED%99%94/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%20%EC%8A%A4%ED%82%AC%20%ED%94%84%EB%A0%88%EC%A0%A0%ED%85%8C%EC%9D%B4%EC%85%98.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item2-6.png"
                    alt="img"
                  />
                  <p class="book-title">비즈니스 스킬<br />이메일</p>
                  <ul class="book-level">
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/2%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%ED%9A%8C%ED%99%94/%EB%B9%84%EC%A6%88%EB%8B%88%EC%8A%A4%20%EC%8A%A4%ED%82%AC%20%EC%9D%B4%EB%A9%94%EC%9D%BC.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <p class="text1">테마 코스</p>
              <p class="text2">
                책 한 권으로 2주만에 중국어 익히기!<br />각 테마별 필수 표현과
                예문, 더불어 중국 문화를 쉽고 빠르게 배울 수 있는 수업이
                가능합니다.
              </p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item3-1.png"
                    alt="img"
                  />
                  <p class="book-title">속이 뻥! 뚫리는<br />생활 중국어 1</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/3%ED%85%8C%EB%A7%88%20%EC%BD%94%EC%8A%A4/%EC%86%8D%EC%9D%B4%20%EB%BB%A5%21%20%EB%9A%AB%EB%A6%AC%EB%8A%94%20%EC%83%9D%ED%99%9C%20%EC%A4%91%EA%B5%AD%EC%96%B41.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item3-2.png"
                    alt="img"
                  />
                  <p class="book-title">속이 뻥! 뚫리는<br />생활 중국어 2</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                    <li>3 중급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/3%ED%85%8C%EB%A7%88%20%EC%BD%94%EC%8A%A4/%EC%86%8D%EC%9D%B4%20%EB%BB%A5%21%20%EB%9A%AB%EB%A6%AC%EB%8A%94%20%EC%83%9D%ED%99%9C%20%EC%A4%91%EA%B5%AD%EC%96%B42.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item3-3.png"
                    alt="img"
                  />
                  <p class="book-title">속이 뻥! 뚫리는<br />여행 중국어 1</p>
                  <ul class="book-level">
                    <li>1 입문</li>
                    <li>2 초급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/3%ED%85%8C%EB%A7%88%20%EC%BD%94%EC%8A%A4/%EC%86%8D%EC%9D%B4%20%EB%BB%A5%21%20%EB%9A%AB%EB%A6%AC%EB%8A%94%20%EC%97%AC%ED%96%89%20%EC%A4%91%EA%B5%AD%EC%96%B41.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item3-4.png"
                    alt="img"
                  />
                  <p class="book-title">속이 뻥! 뚫리는<br />여행 중국어 2</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                    <li>3 중급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/3%ED%85%8C%EB%A7%88%20%EC%BD%94%EC%8A%A4/%EC%86%8D%EC%9D%B4%20%EB%BB%A5%21%20%EB%9A%AB%EB%A6%AC%EB%8A%94%20%EC%97%AC%ED%96%89%20%EC%A4%91%EA%B5%AD%EC%96%B42.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <p class="text1">토론 코스</p>
              <p class="text2">
                중국 이문화에 대한 이해를 도울 수 있는 다양한 주제!<br />최신
                이슈되는 토론 주제를 활용한 토론수업으로 중국에 대한 이해를
                돕고, 흥미있는 수업이 가능합니다.
              </p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item4-1.png"
                    alt="img"
                  />
                  <p class="book-title">토론</p>
                  <ul class="book-level">
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/4%ED%86%A0%EB%A1%A0%20%EC%BD%94%EC%8A%A4/%ED%86%A0%EB%A1%A0.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <p class="text1">시험대비 코스</p>
              <p class="text2">
                시험대비 완성과정, 어휘와 핵심문장 패턴을 익히고<br />1:1 수업을
                통해 실전 감각과 시험 전략을 키웁니다.
              </p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item5-1.png"
                    alt="img"
                  />
                  <p class="book-title">TSC 가볍게<br />뛰어넘기</p>
                  <ul class="book-level">
                    <li>2 초급</li>
                    <li>3 중급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/5%EC%8B%9C%ED%97%98%EB%8C%80%EB%B9%84%20%EC%BD%94%EC%8A%A4/TSC%20%EA%B0%80%EB%B3%8D%EA%B2%8C%20%EB%9B%B0%EC%96%B4%EB%84%98%EA%B8%B0.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item5-2.png"
                    alt="img"
                  />
                  <p class="book-title">TSC 한번에<br />달성하기</p>
                  <ul class="book-level">
                    <li>3 중급</li>
                    <li>4 고급</li>
                  </ul>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/5%EC%8B%9C%ED%97%98%EB%8C%80%EB%B9%84%20%EC%BD%94%EC%8A%A4/TSC%20%ED%95%9C%EB%B2%88%EC%97%90%20%EB%8B%AC%EC%84%B1%ED%95%98%EA%B8%B0.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
              </ul>
            </div>
            <div>
              <p class="text1">주니어 중국어</p>
              <p class="text2">
                기초 발음부터 응용 표현까지 중국어의 모든 것<br />주니어
                중국어회화 팔선생 주니어 중국어
              </p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-1.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol1</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B41.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-2.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol2</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B42.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-3.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol3</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B43.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-4.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol4</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B44.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-5.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol5</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B45.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-6.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol6</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B46.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-7.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol7</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B47.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con4/item6-8.png"
                    alt="img"
                  />
                  <p class="book-title">팔선생<br />주니어 중국어<br />Vol8</p>
                  <p
                    class="book-review"
                    @click="
                      goSite(
                        'https://kr.object.ncloudstorage.com/carrotchinese/%EC%BB%A4%EB%A6%AC%ED%81%98%EB%9F%BC/6%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B4/%ED%8C%94%EC%84%A0%EC%83%9D%20%EC%A3%BC%EB%8B%88%EC%96%B4%20%EC%A4%91%EA%B5%AD%EC%96%B48.pdf'
                      )
                    "
                  >
                    미리보기
                  </p>
                </li>
              </ul>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings1: {
        arrows: false,
        swipeToSlide: false,
        infinite: true,
        slidesToScroll: 1,
        focusOnSelect: true,
        slidesToShow: 6,
        initialSlide: 0,
        asNavFor: null,
      },
      settings2: {
        arrows: false,
        swipeToSlide: false,
        infinite: true,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        focusOnSelect: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        adaptiveHeight: true,
        initialSlide: 0,
        asNavFor: null,
      },
    };
  },
  mounted() {
    this.settings1.asNavFor = this.$refs.c2;
    this.settings2.asNavFor = this.$refs.c1;
  },
  methods: {
    goSite(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: calc(100% - 40px);
  margin: 0 auto;

  @media screen and (min-width: 1050px) {
    max-width: 1000px;
  }
}

.con4 {
  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 35px;
    padding: 85px 0 72px;

    @media screen and (min-width: 1050px) {
      gap: 60px;
      padding: 160px 0 128px;
    }

    p {
      font-size: 30px;
      font-weight: 700;
      color: #09090b;
      text-align: center;

      @media screen and (min-width: 1050px) {
        font-size: 50px;
      }
    }

    ul {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 28px;

      @media screen and (min-width: 1050px) {
        gap: 36px;
      }

      li {
        width: 100%;
        max-width: 146px;
        font-size: 14px;
        font-weight: 500;
        color: #09090b;
        text-align: center;
        padding: 15px 0;
        border-radius: 12px;
        cursor: pointer;

        @media screen and (min-width: 1050px) {
          max-width: 186px;
          font-size: 20px;
          padding: 16px 0;
        }

        &:nth-of-type(1) {
          background-color: #e5e7eb;
          border: 1px solid #e5e7eb;
        }

        &:nth-of-type(2) {
          border: 1px solid #9ca3af;
        }
      }
    }
  }

  .bottom {
    position: relative;
    padding: 64px 0 85px;
    background-color: #26292a;

    @media screen and (min-width: 1050px) {
      padding: 95px 0 160px;
    }

    &::before {
      content: "";
      display: block;
      width: 1px;
      height: 86px;
      background-color: #d1d5db;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -52px;

      @media screen and (min-width: 1050px) {
        height: 122px;
        top: -86px;
      }
    }

    :deep(.title-slide) {
      margin-bottom: 58px;

      @media screen and (min-width: 1050px) {
        margin-bottom: 87px;
      }

      .slick-list {
        .slick-track {
          display: grid !important;
          grid-template-columns: repeat(3, 1fr);
          justify-content: center;
          gap: 7px;

          @media screen and (min-width: 1050px) {
            display: flex !important;
            justify-content: space-between;
            gap: 33px;
          }

          &::before,
          &::after {
            display: none;
          }

          .slick-slide {
            width: 100% !important;

            @media screen and (min-width: 1050px) {
              width: auto !important;
            }

            > div {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              padding: 16px 14px;
              background-color: #374151;
              border-radius: 12px;
              cursor: pointer;

              @media screen and (min-width: 1050px) {
                height: auto;
                padding: 10px 15px;
                background-color: transparent;
                border-radius: 21px;
              }

              > div {
                > p {
                  align-self: stretch;
                  height: 100%;
                  font-size: 14px;
                  font-weight: 500;
                  color: #9ca3af;
                  text-align: center;

                  @media screen and (min-width: 1050px) {
                    align-self: auto;
                    font-size: 18px;
                  }
                }
              }
            }

            &.slick-current {
              > div {
                background-color: #7b53eb;

                > div {
                  > p {
                    color: #ffffff;
                  }
                }
              }
            }
          }
        }
      }
    }

    :deep(.content-slide) {
      .text1 {
        font-size: 24px;
        font-weight: 700;
        color: #ffffff;
        text-align: center;
        margin-bottom: 16px;

        @media screen and (min-width: 1050px) {
          font-size: 40px;
          margin-bottom: 26px;
        }
      }

      .text2 {
        font-size: 14px;
        color: #e5e7eb;
        text-align: center;
        line-height: 20px;
        margin-bottom: 40px;

        @media screen and (min-width: 1050px) {
          font-size: 20px;
          line-height: 35px;
          margin-bottom: 55px;
        }
      }

      .slick-list {
        .slick-track {
          .slick-slide {
            > div {
              > div {
                > ul {
                  display: grid !important;
                  grid-template-columns: repeat(2, 1fr);
                  gap: 32px;
                  padding: 0 10px;

                  @media screen and (min-width: 1050px) {
                    grid-template-columns: repeat(4, 1fr);
                    gap: 50px 45px;
                  }

                  img {
                    margin-bottom: 16px;

                    @media screen and (min-width: 1050px) {
                      margin-bottom: 27px;
                    }
                  }

                  .book-title,
                  .book-level,
                  .book-review {
                    text-align: center;
                  }

                  .book-title {
                    font-weight: 700;
                    color: #ffffff;
                    margin-bottom: 8px;

                    @media screen and (min-width: 1050px) {
                      font-size: 30px;
                      margin-bottom: 12px;
                    }
                  }

                  .book-level {
                    display: flex;
                    justify-content: center;
                    gap: 8px;
                    margin-bottom: 8px;

                    @media screen and (min-width: 1050px) {
                      gap: 12px;
                      margin-bottom: 12px;
                    }

                    li {
                      font-size: 12px;
                      font-weight: 500;
                      color: #b6bac3;
                      padding: 6px 14px;
                      border: 1px solid #b6bac3;
                      border-radius: 20px;
                    }
                  }

                  .book-review {
                    font-size: 12px;
                    font-weight: 500;
                    color: #b6bac3;
                    text-decoration: underline;
                    cursor: pointer;

                    @media screen and (min-width: 1050px) {
                      font-size: 14px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
